import { IRootState } from '../../CorePackage/MainModule/interfaces/IRootState';

export const getErvkOrganisationsSearchQuery = (state: IRootState) =>
  state.changeKnoInMeasure.ervkKnoOrganisationSearchQuery;
export const getKnoErvkOrganisations = (state: IRootState) => state.changeKnoInMeasure.ervkKnoOrganisations;

export const getMeasureNumbersSearchQuery = (state: IRootState) => state.changeKnoInMeasure.measureNumbersSearchQuery;
export const getMeasureNumbers = (state: IRootState) => state.changeKnoInMeasure.measureNumbers;

export const getHistoryChangesItems = (state: IRootState) => state.changeKnoInMeasure.historyChangesItems;
